import { SLOTS } from './slots.js'

// Quest templates. Ordered by drag-reorder (position; `rank` is the row's place in
// the listed order); no detail page — the primary link opens the edit form. The
// capture-mode badge map is inline here (its labels/colors differ from the shared
// `capture_mode` domain in lib/ui/badges.js, which has no `dual_photo`).
// Auto-approve and geofence are per-quest settings surfaced on the edit form, not
// in the list.
export default {
  key: 'quest',
  label: 'Quest',
  icon: 'quests',
  columns: [
    { slot: SLOTS.PRIMARY, field: 'name', subtitle: 'display_name', link: 'url', minWidth: 'min-w-56' },
    { slot: SLOTS.CONTEXT, field: 'area.name', label: 'College Town', areaScoped: true, link: 'area.url' },
    { slot: SLOTS.STATUS, field: 'active', label: 'Active', renderer: 'toggle' },
    { slot: SLOTS.METADATA, field: 'rank', label: 'Rank', renderer: 'points', align: 'right' },
    {
      slot: SLOTS.METADATA,
      field: 'capture_mode',
      label: 'Type',
      renderer: 'state_badge',
      badges: {
        photo: { label: 'Photo', badgeClass: 'badge-neutral' },
        dual_photo: { label: 'Dual photo', badgeClass: 'badge-info' },
        video: { label: 'Video', badgeClass: 'badge-error' }
      }
    },
    { slot: SLOTS.METADATA, field: 'point_source.points', label: 'Award', renderer: 'award', unit: 'pts', align: 'right' },
    { slot: SLOTS.METADATA, field: 'visible_schedule', label: 'Visible', renderer: 'schedule' },
    { slot: SLOTS.METADATA, field: 'active_schedule', label: 'Active schedule', renderer: 'schedule' }
  ],
  empty: { icon: 'quests', message: 'No quest templates found.' },
  defaultView: 'table',
  compact: { show: [SLOTS.PRIMARY, SLOTS.CONTEXT, SLOTS.STATUS] }
}
